import Vue from 'vue';

export default {
    PROCESS_RES: (state, data) => {
        state.items = data.items;

        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    },

    SAVE_FORM_COMPONENT_ANSWER: (state, data) => {
        const answer = state.items.find(it => it.id === data.id);

        if (answer && answer.answers == 0) {
            // If answers count equals to zero - increment
            // answers count and set new status (for better performance)
            Vue.set(answer, 'answers', 1);
        }

        Vue.set(answer, 'client', data.client);
        Vue.set(answer, 'status', data.status);
        Vue.set(answer, 'comment', data.comment);
    }
};
